import React from "react";
import AddCamionForm from "./AddCamionForm";

const AddCamion = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Vehiculo"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddCamionForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddCamion;
